import React from "react";
import { Link } from "react-router-dom";
import { Hexagon } from "lucide-react";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen nova-aurora flex items-center justify-center px-4 py-12">
      <div className="absolute inset-0 nova-grid opacity-20 pointer-events-none" />
      <div className="relative w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2.5 mb-8">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-gradient-to-br from-violet-500 to-cyan-500 btn-glow"><Hexagon className="w-5 h-5 text-white" strokeWidth={2.4} /></span>
          <div className="font-display font-bold text-white text-xl">Nova Web Solutions</div>
        </Link>
        <div className="glass-strong rounded-3xl p-8">
          <h1 className="font-display text-2xl font-bold text-white text-center">{title}</h1>
          {subtitle && <p className="text-sm text-slate-400 text-center mt-2 mb-6">{subtitle}</p>}
          {children}
        </div>
        {footer && <div className="text-center mt-6 text-sm text-slate-400">{footer}</div>}
      </div>
    </div>
  );
}
